import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

@Component({
  selector: 'cc-messages-row',
  templateUrl: './messages-row.component.html',
  styleUrls: ['./messages-row.component.scss']
})
export class MessagesRowComponent implements OnInit {
  @Input() header: string;
  @Input() description: string;
  @Input() opened: boolean;
  @Input() type: string;
  @Input() msisdnId: string;
  @Input() numberConfig: any;
  @Input() canBeEnabled: boolean;
  @Input() permission: string;

  @Output() changeOpened = new EventEmitter();
  @Output() inboundSettingsChanged = new EventEmitter();
  @Output() settingsChanged = new EventEmitter();

  //temp variables
  @Input() projectId;
  public settings: any = {
    voiceMailDrop: {}
  };
  public url;

  constructor(private http: HttpClient, private router: Router) {}

  ngOnInit() {
    this.url = {
      voiceMailDrop: `/outbound/configuration/numbers/${this.msisdnId}/voicemaildrop`,
      welcomeMessage: `/inbound/configuration/numbers/${this.msisdnId}/receive/welcome-message`,
      onHold: `/inbound/configuration/numbers/${this.msisdnId}/receive/hold-message`,
      voiceMailNoAgents: `/inbound/configuration/numbers/${this.msisdnId}/receive/voicemail`,
      promptNoAgents: `/inbound/configuration/numbers/${this.msisdnId}/receive/prompt`,
      voiceMailDontReceive: `/inbound/configuration/numbers/${this.msisdnId}/dont-accept/voicemail`,
      promptDontReceive: `/inbound/configuration/numbers/${this.msisdnId}/dont-accept/prompt`
    }[this.type];

    if (this.type === 'voiceMailDrop') {
      this.http.get(`/outbound/configuration/numbers/${this.msisdnId}`).subscribe((res: any) => {
        this.settings.voiceMailDrop = { ...res };
      });
    }
  }

  get receiveCallConfig() {
    return this.numberConfig.receiveCallConfiguration;
  }

  get dontAcceptCallConfig() {
    return this.numberConfig.dontAcceptCallConfiguration;
  }

  refresh() {
    if (this.type === 'voiceMailDrop') {
      this.http.get(`/outbound/configuration/numbers/${this.msisdnId}`).subscribe((res: any) => {
        this.settings.voiceMailDrop = res;
        this.settingsChanged.next(res);
      });
    } else {
      this.http.get(`/inbound/configuration/numbers/${this.msisdnId}`).subscribe(res => {
        this.numberConfig.receiveCallConfiguration = res['receiveCallConfiguration'];
        this.numberConfig.dontAcceptCallConfiguration = res['dontAcceptCallConfiguration'];
        this.settingsChanged.next(res);
      });
    }
  }

  get fileName() {
    return {
      voiceMailDrop: this.settings.voiceMailDrop.voiceMailFilename,
      welcomeMessage: this.receiveCallConfig.agentLoggedInStrategy.welcomeMessageFile,
      onHold: this.receiveCallConfig.agentLoggedInStrategy.holdMessageFile,
      voiceMailNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.voicemailMessageFile,
      promptNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.promptMessageFile,
      promptDontReceive: this.dontAcceptCallConfig.promptMessageFile,
      voiceMailDontReceive: this.dontAcceptCallConfig.voicemailMessageFile
    }[this.type];
  }

  get bucketFileName() {
    return {
      voiceMailDrop: this.settings.voiceMailDrop.voiceMailFilename,
      welcomeMessage: this.receiveCallConfig.agentLoggedInStrategy.welcomeMessageFile,
      onHold: this.receiveCallConfig.agentLoggedInStrategy.holdMessageFile,
      voiceMailNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.voicemailMessageFile,
      promptNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.promptMessageFile,
      promptDontReceive: this.dontAcceptCallConfig.promptMessageFile,
      voiceMailDontReceive: this.dontAcceptCallConfig.voicemailMessageFile
    }[this.type];
  }

  get isActive() {
    return {
      voiceMailDrop: this.settings.voiceMailDrop.voiceMailDropEnabled || false,
      welcomeMessage: this.receiveCallConfig.agentLoggedInStrategy.welcomeMessageEnabled || false,
      onHold: this.receiveCallConfig.agentLoggedInStrategy.holdMessageEnabled || false,
      promptNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.strategy === 'PROMPT' || false,
      voiceMailNoAgents: this.receiveCallConfig.agentNotLoggedInStrategy.strategy === 'VOICEMAIL' || false,
      promptDontReceive: this.dontAcceptCallConfig.strategy === 'PROMPT' || false,
      voiceMailDontReceive: this.dontAcceptCallConfig.strategy === 'VOICEMAIL' || false
    }[this.type];
  }

  remove() {
    this.refresh();
  }

  changeActiveState(enabled) {
    if (this.type === 'voiceMailDrop') {
      this.http
        .post(
          `/outbound/configuration/numbers/${this.msisdnId}/enable-voicemaildrop`,
          {},
          {
            params: {
              enabled
            }
          }
        )
        .subscribe((res: any) => {
          this.refresh();
        });
    } else if (this.type === 'welcomeMessage') {
      this.http
        .post(
          `/inbound/configuration/numbers/${this.msisdnId}/receive/welcome-message/enable`,
          {},
          {
            params: {
              enabled
            }
          }
        )
        .subscribe(() => {
          this.refresh();
        });
    } else if (this.type === 'onHold') {
      this.http
        .post(
          `/inbound/configuration/numbers/${this.msisdnId}/receive/hold-message/enable`,
          {},
          {
            params: {
              enabled
            }
          }
        )
        .subscribe(() => {
          this.refresh();
        });
    }
  }

  upgradeAccount() {
    this.router.navigateByUrl('/my-account');
  }
}
